import './PopupFooter.less';

import React from 'react';

export const PopupFooter = ({leftControl, leftSecondaryControl, rightControl}) => {
	return <ul className="popup-footer">
		{
			leftControl && (
				<div className="popup-footer__left-control">
					{leftControl}
				</div>
			)
		}
		{
			leftSecondaryControl && (
				<div className="popup-footer__left-secondary-control">
					{leftSecondaryControl}
				</div>
			)
		}
		{
			rightControl && (
				<div className="popup-footer__right-control">
					{rightControl}
				</div>
			)
		}
	</ul>
}

